import React from 'react';
import { ReactComponent as Logo } from '../../../../../../infrastructure/assets/images/logo-canvas.svg';
import { Container } from './styles';

interface Props {
  onClick: () => void;
}

const ButtonCanvas: React.FC<Props> = (props) => {
  return (
    <Container onClick={props.onClick}>
      <Logo width={'100%'} height={'100%'} />
    </Container>
  );
};

export { ButtonCanvas };
